import React from "react";
import { InputSwitch } from "primereact/inputswitch";
import { classNames } from "primereact/utils";

interface SwitchProps {
  id?: string;
  name?: string;
  checked: boolean;
  label?: string;
  subLabel?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  error?: string;
  onChange?: (e: { value: boolean }) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export function Switch({
  id,
  name,
  checked,
  label,
  subLabel,
  disabled = false,
  required = false,
  className,
  error,
  onChange,
  onBlur,
}: SwitchProps) {
  const inputId = id || name;

  return (
    <div className={"field"}>
      <div style={{ display: "flex", gap: "1rem" }}>
        <InputSwitch
          id={inputId}
          name={name}
          checked={checked}
          disabled={disabled}
          className={classNames({ "p-invalid": error }, className)}
          onChange={onChange}
          onBlur={onBlur}
        />
        <div>
          {label && (
            <label htmlFor={inputId} className="block mb-2">
              {label}
              {required && <span className="text-red-500 ml-1">*</span>}
            </label>
          )}
          {subLabel && <span className="text-neutral-500 text-sm block mt-1">{subLabel}</span>}
        </div>
      </div>
      {error && <small className="p-error block mt-1">{error}</small>}
    </div>
  );
}
